export default __webpack_public_path__ + "static/media/clock-icon.80f2e0a4.svg";